export default "/images/38c015613043e1627c65ae3f97b4899e.avif";